import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingBrandingEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingBrandingEntity
